import CssBaseline from '@mui/joy/CssBaseline'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useGate } from 'effector-react'
import { parse, stringify } from 'query-string'
import { HelmetProvider } from 'react-helmet-async'
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'
import { Routing } from '~/pages'
import { featureFlagModel } from '~/shared/lib/featureFlag'
import { history } from '~/shared/lib/history'
import { NotificationsProvider } from '~/shared/lib/notifications'
import { ErrorBoundary } from '~/shared/ui/ErrorBoundary'
import { GlobalStyles } from '~/shared/ui/GlobalStyles'
import { ReloadSw } from '~/widgets/common/ReloadSw'
import { ScrollTop } from './ui/ScrollTop'

const queryClient = new QueryClient()

export function App() {
  useGate(featureFlagModel.Gate)

  return (
    <ErrorBoundary>
      <CssBaseline />
      <GlobalStyles />
      <ScrollTop />
      <ReloadSw />

      <NotificationsProvider>
        <HistoryRouter history={history}>
          <QueryParamProvider
            adapter={ReactRouter6Adapter}
            options={{
              searchStringToObject: parse,
              objectToSearchString: stringify,
            }}
          >
            <QueryClientProvider client={queryClient}>
              <HelmetProvider>
                <Routing />
              </HelmetProvider>
            </QueryClientProvider>
          </QueryParamProvider>
        </HistoryRouter>
      </NotificationsProvider>
    </ErrorBoundary>
  )
}
